import { Component, OnInit, Input } from '@angular/core';

import { UserTableService } from 'src/service/user.service';
import { ProductInstanceService, UserService } from 'src/api/services'
import { User } from 'src/api/models';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
  private _productInstanceId: number;
  
  get productInstanceId(): number {
    return this._productInstanceId;
  }

  @Input() set productInstanceId(id: number) {
    this._productInstanceId = id;
    this.getProductInstanceUsers(id);
  }

  public users?: Array<User>;
  public linkedUsers?: Array<number>;
  public remoteData: Observable<User[]>;

  constructor(
    private userService: UserService,
    private productInstanceService: ProductInstanceService,
    private userTableService: UserTableService,
    private toasterService: ToastrService
    ) {
    this.remoteData = this.userTableService.remoteData;

    this.remoteData.subscribe(
      res => {
        this.users = res;
      }
    )
  }

  ngOnInit(): void {
    this.userTableService.get();
  }

  getProductInstanceUsers(productInstanceId: number): void {
    this.productInstanceService.ProductInstanceGetUsersByProductInstanceId(productInstanceId)
      .subscribe(
        res => {
          // todo - on selection change is firing on load due to the line below, how to avoid this?
          this.linkedUsers = res.map(user => user.userId);
        },
        err => {
          console.error("ERROR: getProductInstanceUsers", err);
        }
      )
  }

  /*handleUserLinking(event: IComboSelectionChangeEventArgs) {
    for (const item of event.added) {
      // checks that a user to be linked isn't already linked:
      if (!this.linkedUsers.includes(item)){
        this.linkUser(item);
      }
    }

    for (const item of event.removed) {
      this.unlinkUser(item)
    }
  }*/

  linkUser(userId: number) {
    const args: UserService.UserLinkProductToUserParams = {
      productId: this._productInstanceId,
      description: "Description?",
      userId: userId
    }

    this.userService.UserLinkProductToUser(args)
      .subscribe(
        res => {
          this.toasterService.success(`Successfully Linked User`, "Link User");
        },
        err => {
          this.toasterService.error(`Failed To Link User`, "Link User");
          console.error("ERROR: getUser", err);
        }
      )
  }

  unlinkUser(userId: number) {
    const args: UserService.UserUnlinkProductToUserParams = {
      productId: this._productInstanceId,
      userId: userId
    }

    this.userService.UserUnlinkProductToUser(args)
      .subscribe(
        res => {
          this.toasterService.success(`Successfully Unlinked User`, "Unlink User");
        },
        err => {
          this.toasterService.error(`Failed To Unlink User`, "Unlink User");
          console.error("ERROR: getUser", err);
        }
      )
  }
}
